import type { CSSProperties, ForwardedRef } from 'react'
import { forwardRef } from 'react'
import styles from './style.module.sass'

type LoadingProps = {
	style?: CSSProperties
	inline?: boolean
	className?: string
}

export const Loading = forwardRef(
	(
		{ style, inline, className }: LoadingProps,
		ref: ForwardedRef<HTMLSpanElement>
	) => {
		return (
			<span
				ref={ref}
				role="status"
				aria-label="Loading"
				className={`loadingAnimation ${styles.loadingAnimation} ${
					inline ? styles.inline : ''
				} ${className || ''}`}
				style={style}
			>
				{['dot1', 'dot2', 'dot3'].map((id, i) => (
					<svg
						key={id}
						aria-hidden="true"
						viewBox="0 0 6 6"
						style={{ animationDelay: `${i * 0.1}s` }}
					>
						<circle cx="3" cy="3" r="2" />
						<rect x="1" y="1" width="4" height="4" />
					</svg>
				))}
			</span>
		)
	}
)
